import * as React from 'react';
import { getTimeZoneShortDisplayName } from 'owa-timezone';
import { SurfaceConstants, toPixelString } from 'owa-calendar-surface-core';
import { observer } from 'mobx-react';

const styles = require('./TimeStripHeaderBehavior.scss');

export default observer(function TimeStripHeaderBehavior({
    headerWidth = SurfaceConstants.timeStripDefaultWidth,
    timeZones = [],
}: {
    headerWidth?: number;
    timeZones?: string[];
}) {
    const headerPixelString = toPixelString(headerWidth);
    const timeZoneWidthStyle = { width: headerPixelString };

    return (
        <>
            {timeZones
                .map(timeZoneId => (
                    <div
                        key={timeZoneId}
                        className={styles.timeZonePanel}
                        style={timeZoneWidthStyle}>
                        {getTimeZoneShortDisplayName(timeZoneId)}
                    </div>
                ))
                .reverse()}
        </>
    );
});
